import { createSlice } from "@reduxjs/toolkit";
import { fetchSystemVersion } from "../thunks/versionThunk";

const versionSlice = createSlice({
  name: "version",
  initialState: {
    version: "0.2.0", // Fallback version
    name: "clinicflow",
    environment: "unknown",
    timestamp: null,
    status: "idle", // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null,
  },
  reducers: {
    clearVersionError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchSystemVersion.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchSystemVersion.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.version = action.payload.version;
        state.name = action.payload.name;
        state.environment = action.payload.environment;
        state.timestamp = action.payload.timestamp;
      })
      .addCase(fetchSystemVersion.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearVersionError } = versionSlice.actions;
export default versionSlice.reducer;